"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileCommunicator = void 0;
// Mobile Communicator
const mobileCommunicator_constants_1 = require("./mobileCommunicator.constants");
const mobileCommunicator_errors_1 = require("./mobileCommunicator.errors");
class MobileCommunicator {
    constructor(deviceConnector, mobileHandler) {
        this.init = () => __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.mobileHandler.init();
            }
            catch (error) {
                throw new Error('Error initializing Mobile Handler');
            }
        });
        this.request = (type, payload, timeout) => __awaiter(this, void 0, void 0, function* () {
            try {
                if (timeout) {
                    return yield this.mobileHandler.callWithTimeout(type, timeout, payload);
                }
                return yield this.mobileHandler.call(type, payload);
            }
            catch (err) {
                const errMessage = err instanceof Error ? err.message : mobileCommunicator_constants_1.ACTION_ERROR;
                throw new mobileCommunicator_errors_1.MobileCommunicatorError(errMessage);
            }
        });
        this.listen = (type, onSuccess, onError) => {
            try {
                this.deviceConnector.listen((eventType, payload) => {
                    try {
                        if (type === eventType) {
                            onSuccess(payload);
                        }
                    }
                    catch (error) {
                        onError === null || onError === void 0 ? void 0 : onError(error);
                    }
                });
            }
            catch (error) {
                throw new Error('Error executing listen');
            }
        };
        this.deviceConnector = deviceConnector;
        this.mobileHandler = mobileHandler;
    }
}
exports.MobileCommunicator = MobileCommunicator;
//# sourceMappingURL=mobileCommunicator.js.map